import { Record } from 'immutable';
import { OLAF, PANTERA } from 'HubStyleTokens/colors';
const DEFAULT_HEADINGS_FONT = 'helvetica';
const DEFAULT_ARTICLE_BODY_FONT = 'georgia, palatino';
const DEFAULT_TOC_FONT = 'helvetica';
const DEFAULT_BREADCRUMBS_FONT = 'helvetica';
const ThemeSettingsRecord = Record({
  breadcrumbs_font: {
    font: DEFAULT_BREADCRUMBS_FONT
  },
  toc_font: {
    font: DEFAULT_TOC_FONT
  },
  article_body_font: {
    font: DEFAULT_ARTICLE_BODY_FONT
  },
  header_welcome_message_color: {
    color: PANTERA,
    opacity: 100
  },
  headings_font: {
    font: DEFAULT_HEADINGS_FONT
  },
  links_color: {
    color: PANTERA,
    opacity: 100
  },
  mobile_nav_menu_color: {
    color: OLAF,
    opacity: 100
  },
  nav_bar_link_color: {
    color: PANTERA,
    opacity: 100
  },
  social_icon_shape_and_color: 'circle_color',
  theme_type: 'tiles'
});
export default ThemeSettingsRecord;